import * as React from "react";

import "./table.scss";

import {cs}                         from "@Common/react/chain-services";
import {consumeContext}             from "@Common/react/context";
import {UseState}                   from "@Common/react/use-state";
import {DataTableD1}                from "@Common/ui-components/heavy/common/design2/data-table/data-table-d1";
import {getPageSummary}             from "@Common/ui-components/heavy/common/design2/data-table/get-page-summary";
import {PageList}                   from "@Common/ui-components/heavy/common/design2/pagination-ui/page-list/page-list";
import {PAGE_SIZE_ALL, PageSize}    from "@Common/ui-components/heavy/common/design2/pagination-ui/page-size/page-size";
import {SliderCheckbox}             from "@Common/ui-components/slider-checkbox/slider-checkbox";
import {pageSizesAdminAdBudget,
        helperTextAdminAdBudget}    from "@Xpresso/routes/account/admin/accounting/admin-ad-budgets-route/admin-ad-budgets-route"
import {InlineAmountForm}           from "../../common/inline-amount-form/inline-amount-form";
import {InlineSelect}               from "../inline-select/inline-select";

export const Table = ({budgets}) => cs(
    consumeContext("apis"),
    ["pageSize", (_, next) => UseState({_key: "pageSize", initValue: 10, next})],
    ({apis, pageSize}) => DataTableD1({
        className: "table-3rd",
        columns: [
            {
                className: "toggle",
                render: () => <>
                    <div className="note" xd-qa-type="label" xd-qa-name="Note">
                       {helperTextAdminAdBudget}
                    </div>
                    {InlineSelect({
                    label: "ALLOW",
                    disabled: budgets.value.length === 0,
                    items: [
                        {
                            label: "Allow All",
                            onSelect: () => {
                                budgets.change((bs) => bs.map((b1) => ({
                                    ...b1,
                                    allow: true,
                                })))
                                budgets?.value.map((b) => {
                                    apis.next.adBudgets.setUserAdBudget({
                                        idBranch: b.agent.idBranch,
                                        list: [{
                                            idAgent: b.agent.idAgent,
                                            amount: b.amount,
                                            status: true,
                                        }],
                                    })
                                })
                            },
                        },
                        {
                            label: "Disallow All",
                            onSelect: () => {
                                budgets.change((bs) => bs.map((b1) => ({
                                    ...b1,
                                    allow: false,
                                })))
                                budgets?.value.map((b) => {
                                    apis.next.adBudgets.setUserAdBudget({
                                        idBranch: b.agent.idBranch,
                                        list: [{
                                            idAgent: b.agent.idAgent,
                                            amount: b.amount,
                                            status: false,
                                        }],
                                    })
                                })
                            },
                        },
                    ],
                })}</>,
            },
            {
                label: "USER NAME",
                width: "99%",
                className: "user-name",
                domAttrs: {
                    "xd-qa-type": "label",
                    "xd-qa-name": "User Name",
                },
            },
            {
                label: "AMOUNT",
                className: "amount",
                domAttrs: {
                    "xd-qa-type": "label",
                    "xd-qa-name": "Amount",
                },
            },
        ],
        rows: budgets.value?.map((b, i) => ({
            key: b.agent.idAgent,
            xdQaName: b.agent.idAgent,
            columns: [
                {
                    render: () => SliderCheckbox({
                        xdQaName: "Slider Checkbox",
                        value: b.allow,
                        onChange: () => {
                            budgets.change((bs) => bs.map((b1) => b1.agent.idAgent !== b.agent.idAgent ? b1 : ({
                                ...b,
                                allow: !b.allow,
                            })))
                            apis.next.adBudgets.setUserAdBudget({
                                idBranch: b.agent.idBranch,
                                list: [{
                                    idAgent: b.agent.idAgent,
                                    amount: b.amount,
                                    status: !b.allow,
                                }],
                            })
                        },
                    }),
                },
                {
                    render: () => b.agent?.name || getAgentFullName(b.agent) || "",
                    sortValue: () => (b?.agent?.name)?.toLowerCase() || (getAgentFullName(b?.agent))?.toLowerCase() || "",
                    domAttrs: {
                        "xd-qa-type": "label",
                        "xd-qa-name": "Name",
                    },
                },
                {
                    render: () => InlineAmountForm({
                        amount: b.amount,
                        readOnly: !b.allow,
                        onChange: (v) => {
                            budgets.change((bs) => bs.map((b1) => b1.agent.idAgent !== b.agent.idAgent ? b1 : ({
                                ...b,
                                amount: v,
                            })))
                            apis.next.adBudgets.setUserAdBudget({
                                idBranch: b.agent.idBranch,
                                list: [{
                                    idAgent: b.agent.idAgent,
                                    amount: v,
                                    status: b.allow,
                                }],
                            })
                        },
                    }),
                },
            ],
        })),
        pageSize: pageSize.value,

        getFooter: ({colCount, pagination}) => ({
            columns: [
                {
                    colSpan: colCount,
                    render: () => (
                        <div className="controls">
                            {PageSize({
                                state: pageSize,
                                pageSizeMessage: "Rows per page",
                                sizes: pageSizesAdminAdBudget,
                                extraSizes: [PAGE_SIZE_ALL],
                            })}

                            {pagination.active && (
                                <div className="page-list">
                                    {PageList({...pagination})}
                                </div>
                            )}
                            {getPageSummary({
                                pageIndex: pagination.state.value,
                                pageSize: pageSize.value,
                                count: budgets.value.length,
                            })}
                        </div>
                    ),
                },
            ],
        }),

    }),
)

const getAgentFullName = (agent) => [agent["agentNameFirst"], agent["agentNameLast"]].filter(v=>v).join(" ");